<template>
  <div id="app">
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    if (!sessionStorage) {
      alert('您的浏览器版本过低，请升级您浏览器！')
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body{
  background: #f0f0f0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f0f0f0;
  width: 100%;
  color: #424242;
}

/**
  copy from old version
 */
.container {
  width: 100%;
  margin: 0 auto;
}
.flex {
  display: flex;
}
.bgfff {
  background: #fff;
}
.footer-title {
  padding: 12px 0;
}
.step-box {
  height: auto;
  background: transparent;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 75%;
  margin: 48px auto;
  text-align: center;
}
#app .el-step__head.is-finish {
  color: #fff;
  border-color: #17202e;
}
#app .el-step__head.is-finish .el-step__icon.is-text {
  background: #17202e;
  border-color: #17202e;
  color: #fff;
}
#app .el-step__title.is-finish {
  color: #17202e;
}
#app .el-step__icon.is-text {
  color: #c0c4cc;
  border-color: #c0c4cc;
}
#app .el-step__title.is-process {
  color: #c0c4cc;
}
#app .el-step__head.is-process {
  border-color: #c0c4cc;
}
.el-loading-mask {
  position: fixed;
}
.el-message-box__wrapper{
  z-index: 9999 !important;
}
.el-step.is-horizontal .el-step__line{
  height: 1px;
}
.el-step__title.is-process{
  font-weight: normal;
}
.el-tabs__active-bar{
  background-color: var(--themeColor);
}
.el-tabs__item.is-active, .el-tabs__item:hover{
  color: var(--themeColor);
}
</style>



// WEBPACK FOOTER //
// src/App.vue